import React, {useState} from 'react';
import LeaveMessage from "./LeaveMessage";

function LeaveMessageChat({prefLang,messageInfo, setIsLang, setFormRequested,setNoFeedback, openBot, setOpenBot, chatIsClose,closeChatEff,setChatIsClose,setCloseChatEff,setCloseFloat, customerInfo, title,teams,
    setStartChat, setOpenFeedback, socket, botInfo, message}) {
    const [leaveMessage, setLeaveMessage] = useState(false)
    // console.log("print the customerInfo", messageInfo)
    return(
        <div className="li-item-wrapper">
            <div className="leave-message" onClick={() => setLeaveMessage(true)}>
                <i className="bot icon-comment-new"></i>{title}
            </div>
            <span className="helper-text">{botInfo?.data?.mobileAppConfig?.queryResolved ? botInfo?.data?.mobileAppConfig?.queryResolved?.[prefLang] : "Your query will be resolved offline"}</span>
            <LeaveMessage setFormRequested={setFormRequested} prefLang={prefLang} chatIsClose={chatIsClose} setNoFeedback={setNoFeedback} closeChatEff={closeChatEff} setChatIsClose={setChatIsClose} setCloseChatEff={setCloseChatEff} setCloseFloat={setCloseFloat}  setIsLang={setIsLang} messageInfo={messageInfo} openBot={openBot} setOpenBot={setOpenBot} customerInfo={customerInfo} socket={socket} teams={teams}  leaveMessage={leaveMessage} setLeaveMessage={setLeaveMessage} setStartChat={setStartChat}
             setOpenFeedback={setOpenFeedback} botInfo={botInfo} title={title} message={message} />
        </div>
    )
}
export default LeaveMessageChat;
